import Common from '../../Common'
import Exception from './tbr/Exception'

export interface PbxDadTbrExceptionBody {
	pbx_app_tbr_condition_id: id
	name?: string
	start: string
	end: string
}

const Tbr = class extends Common {
	exception: InstanceType<typeof Exception>

	constructor(headers: ApiHeaders) {
		super(headers)

		this.exception = new Exception(headers)
	}
}

export default Tbr
